import { deskCard, deskEyebrow, deskMuted, deskPrimaryBtn } from "./salesDeskStyles";

function PageHead({ eyebrow, title, body }: { eyebrow: string; title: string; body: string }) {
  return (
    <div>
      <p className={deskEyebrow}>{eyebrow}</p>
      <h1 className="mt-2 text-[32px] font-semibold leading-[1.15] tracking-[-1px]">{title}</h1>
      <p className={`mt-3 max-w-[40rem] ${deskMuted}`}>{body}</p>
    </div>
  );
}

export function SalesDeskStart({
  onLot,
  onConfigure,
}: {
  onLot: () => void;
  onConfigure: () => void;
}) {
  return (
    <div>
      <PageHead eyebrow="Start a sale" title="Choose their starting point." body="A lot unit keeps its serial. A new building is configured one choice at a time." />
      <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2">
        <section className={deskCard}>
          <h2 className="text-[21px] font-semibold">Sell from my lot</h2>
          <p className={`mt-2 ${deskMuted}`}>A specific serial and its existing features travel with the sale.</p>
          <button type="button" onClick={onLot} className={`${deskPrimaryBtn} mt-4 w-full`}>
            Browse my lot →
          </button>
        </section>
        <section className={deskCard}>
          <h2 className="text-[21px] font-semibold">Configure a new building</h2>
          <p className={`mt-2 ${deskMuted}`}>IdeaRoom still builds the quote. This desk will bring it back to the sale.</p>
          <button type="button" onClick={onConfigure} className={`${deskPrimaryBtn} mt-4 w-full`}>
            Start configuring →
          </button>
        </section>
      </div>
    </div>
  );
}
